module.exports = __webpack_public_path__ + "static/media/Hausmart-example2.1386b83e.jpg";